module.exports = __webpack_public_path__ + "static/img/p.27af2ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p.png
// module id = 9LAy
// module chunks = 1